"use client";

import { ReactNode } from "react";
import styles from "./Badge.module.css";

export type BadgeVariant =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "error"
  | "info";
export type BadgeSize = "small" | "medium";

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

export default function Badge({
  children,
  variant = "default",
  size = "small",
  className = "",
}: BadgeProps) {
  const variantClass =
    styles[`badge${variant.charAt(0).toUpperCase() + variant.slice(1)}`];
  const sizeClass =
    styles[`size${size.charAt(0).toUpperCase() + size.slice(1)}`];

  return (
    <span
      className={`${styles.badge} ${variantClass} ${sizeClass} ${className}`}
    >
      {children}
    </span>
  );
}
